import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import eventify from 'Eventify';
import SMTeamLogo from '../SMTeamLogo';
import DateFormatted from '../DateFormatted';

import RCore from 'RCore';
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const scoreWidth = 100;

const MatchCellHeader = styled.div`
    opacity: 0.9;
    padding: 10px 10px;
    font-size: 11px;
`;

const Cell = styled.div`
    position: relative;
    margin: 20px 0;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    .team-home {
        text-align: right;
        img {
        }
    }
    .team-away {
        text-align: left;
        img {
        }
    }

    &:after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -15px;
        right: -15px;
        content: ' ';
        z-index: 0;
        transform: skew(-20deg);
        background-color: ${props => props.theme.primaryColor};
    }
    &:before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50px;
        right: -15px;
        content: ' ';
        z-index: 0;
        transform: skew(-20deg);
        background-color: ${props => props.theme.content.accentColor};
    }
`;

const Team = styled.div`
    width: calc(50% - 60px);
    white-space: nowrap;
    text-align: center;
    font-size: 24px;
    font-weight: normal;
    line-height: 60px;
    position: relative;

    color: ${props => props.theme.color};
    &:after {
        z-index: 1;
        position: absolute;
        content: '';
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        opacity: 0.8;
    }

    & > * {
        position: relative;
        z-index: 3;
        vertical-align: middle;
        display: inline-block;
    }

    .logo-box {
        display: inline-block;
        min-width: 70px;
        text-align: center;
    }
`;

const Score = styled.div`
    position: relative;
    width: 120px;
    height: 60px;
    z-index: 4;
    position: relative;
    color: ${props => props.theme.primaryTextColor};
    display: flex;
    font-size: 14px;
    line-height: 1.1;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    & > * {
        positon: relative;
        z-index: 6;
    }
    &:after {
        z-index: 1;
        position: absolute;
        content: '';
        left: -5px;
        right: -5px;
        top: -5px;
        bottom: -5px;
        transform: skew(-10deg);
        border-radius: 5px;
    }

    .top-sub {
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .top-sub-score {
        font-size: 32px;
        font-weight: 34px;
        font-weight: 700;
    }
    .score {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        line-height: 34px;
        font-weight: 700;
        flex-grow: 1.2;
    }

    .tv-info {
        width: 100%;
        flex-grow: 1;
        display: flex;
        text-transform: uppercase;
        font-weight: 15px;
        font-weight: 700;
        align-items: center;
        justify-content: center;
        backgroundcolor: rgba(0, 0, 0, 0.5);
        font-size: 14px;
    }
`;

const IsLiveLabel = styled.div`
    background: ${props => props.theme.primaryColor};
    color: ${props => props.theme.primaryTextColor};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    transform: translate(0, -50%) rotate(-90deg);
    position: absolute;
    width: 60px;
    height: 30px;
    line-height: 22px;
    box-sizing: border-box;
    padding: 3px 0 5px;
    left: -15px;
    top: 50%;
    transform-origin: center;
`;

const TeamNameHome = styled.div`
    display: inline-block;
    width: calc(100% - 70px);
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: right;
    padding-left: 10px;
    box-sizing: border-box;
`;

const TeamNameAway = TeamNameHome.extend`
    text-align: left;
    padding-right: 10px;
    padding-left: 0;
`;

class MatchCell extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        moment: PropTypes.func,
    };

    render() {
        let { event, lang } = this.props;
        event = eventify(event);

        const tvInfo = event.channel && event.channel.name && <div className="tv-info">{event.channel.name}</div>;
        const isToday = this.context.moment(event.startDate).isSame(new Date(), 'day');
        const isFinished = event.isFinished();
        const isComing = event.isComing();
        const isLive = event.isLive();

        return (
            <Cell>
                {isLive && <IsLiveLabel>Live</IsLiveLabel>}
                <Team className="team-home">
                    <TeamNameHome>{event.homeName}</TeamNameHome>
                    <span className="logo-box">
                        <SMTeamLogo
                            tournamentId={event.tournamentTemplateId}
                            display="logo"
                            teamId={event.homeId}
                            height={40}
                        />
                    </span>
                </Team>
                <Score isLive={isLive}>
                    {isFinished && (
                        <div>
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                        </div>
                    )}
                    {isLive && (
                        <div>
                            <div className="top-sub-score">{event.score.home + ' - ' + event.score.away}</div>
                            {tvInfo}
                        </div>
                    )}
                    {event.isCancelled() && <div>{i18('status.short.cancelled', lang)}</div>}

                    {event.isPostponed() && <div>{i18('status.short.postponed', lang)}</div>}

                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        isToday && (
                            <div>
                                <DateFormatted className="top-sub" date={event.startDate} type="TIME" el="div" />
                                {tvInfo}
                            </div>
                        )}
                    {isComing &&
                        !event.isCancelled() &&
                        !event.isPostponed() &&
                        !isToday && (
                            <div>
                                <DateFormatted className="top-sub" date={event.startDate} type="DATE_SHORT" el="div" />
                                <DateFormatted date={event.startDate} type="TIME" el="div" />
                            </div>
                        )}
                </Score>
                <Team className="team-away">
                    <span className="logo-box">
                        <SMTeamLogo tournamentId={event.tournamentTemplateId} teamId={event.awayId} height={40} />
                    </span>
                    <TeamNameAway>{event.awayName}</TeamNameAway>
                </Team>
            </Cell>
        );
    }
}

MatchCell.propTypes = {
    event: PropTypes.object.isRequired,
};

const Container = ({ children }) => <div>{children}</div>;

export default { MatchCellHeader, MatchCell, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/matchCell/WHMatchCell.js
 **/